import { TState } from '~/src/store';

const selectCallCenterNumber = (state: TState): string => state.city.currentCity.callCenter.replace(/\D/g, '');

export default selectCallCenterNumber;
